<div class="rizk-config">

  <div class="column" *ngIf="mode === 'organizations' || mode === 'both'">

    <div class="header">
      <span>Business Units</span>
      <button class="icon-btn"
              (click)="addItem('business')">
        <i class="pi pi-plus"></i>
      </button>
    </div>

    <div *ngFor="let unit of businessUnits; let i = index; trackBy: trackByIndex"
         class="item"
         pDraggable="business"
         pDroppable="business"
         (onDragStart)="onDragStart(i, 'business')"
         (onDrop)="onDrop(i, 'business')">

      <span class="pi pi-bars drag-handle"></span>

      <input type="text"
             name="businessUnit-{{i}}"
             [(ngModel)]="businessUnits[i]" />

      <button class="icon-btn"
              (click)="removeItem('business', i)">
        <i class="pi pi-trash"></i>
      </button>

    </div>

  </div>

  <div class="column" *ngIf="mode === 'scoring' || mode === 'both'">

    <div class="header">
      <span>Scoring</span>
      <button class="icon-btn"
              (click)="addItem('scoring')">
        <i class="pi pi-plus"></i>
      </button>
    </div>

    <div *ngFor="let score of scoring; let i = index; trackBy: trackByIndex"
         class="item"
         pDraggable="scoring"
         pDroppable="scoring"
         (onDragStart)="onDragStart(i, 'scoring')"
         (onDrop)="onDrop(i, 'scoring')">

      <span class="pi pi-bars drag-handle"></span>

      <input type="text"
             name="scoring-{{i}}"
             [(ngModel)]="scoring[i]" />

      <button class="icon-btn"
              (click)="removeItem('scoring', i)">
        <i class="pi pi-trash"></i>
      </button>

    </div>

  </div>

</div>

<div style="margin-top: 2rem;">
  <button mat-raised-button
          type="button"
          (click)="onSave()">
    Save
  </button>
</div>
